<h2 class="text-center"> Editing Fact Template <span *ngIf="taskTemplate.name!=''"> {{taskTemplate.name}}</span></h2>
<div *ngIf="!editMatching" class="alert alert-info"> Name and upload  do not match</div>
<form [formGroup]="myForm" (ngSubmit)="submit()" enctype="multipart/form-data">
    <div class="form-group">
        <label for="file">File</label>
        <input
            formControlName="file"
            id="file"
            type="file"
            class="form-control"
            (change)="onFileChange($event)">
            <div *ngIf="f.file.touched && f.file.invalid" class="alert alert-danger">
                <div *ngIf="f.file.errors.required">File is required.</div>
            </div>
        </div>
        <button [disabled]="loading" class="btn btn-primary me-4 mt-2" type="submit">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> Submit
        </button>

</form>
